define((require) => {
    "use strict";

    var ImprovedModel = require("shared/zbone/ImprovedModel"),
        _             = require("underscore"),
        Permissions   = require("shared/security/Permissions"),
        Syncer        = require("shared/services/sync/Syncer"),
        RestApi       = require("shared/services/RestApi");

    // The color codes to use when coloring a background for this user
    var BackgroundColorCodes =
        ["#c6c6c6", "#ffff93", "#b0edff", "#ffb1b1", "#caed7f", "#ddcdb0", "#ffc4ff", "#a6c9f6", "#99eec4", "#dfbce9", "#eec699"];

    /**
     * @class {User}
     * The user model, an editor type only.
     */
    return ImprovedModel.extend("User", {

        defaults: {
            id:                 null,
            name:               null,
            version:            null,
            companyId:          null,
            username:           null,
            confirmedAt:        null,
            lastUsedProperties: null,
            serialNumber:       0
        },

        computed: {
            role: {
                deps: ["role"],
                value: function(role) {
                    return Permissions.Roles.of(role);
                }
            },
            displayName: {
                deps: ["name", "username"],
                value: function(name, username) {
                    return name || username;
                }
            },
            backgroundColor: {
                deps: ["serialNumber"],
                value: function(serialNumber) {
                    return BackgroundColorCodes[serialNumber % BackgroundColorCodes.length];
                }
            }
        },

        /**
         * @constructor
         */
        constructor: function() {
            this.__super();

            // Updating a user does not require privileges, guarded by user identity...
            Syncer.State.init(this, {
                permissions: {
                    save:    null, // only own user can edit herself
                    destroy: Permissions.Privileges.ADMIN
                }
            });
        },

        /**
         * Get the URL to the user model.
         *
         * @returns {String} The URL to the user model.
         */
        url: function() {
            if (this.get("id")) {
                return RestApi.pathToSpecificResource(RestApi.Collections.USERS, this.get("id"));
            }
            return RestApi.API_URL + "/" + RestApi.Collections.USERS + "/create";
        },

        setLastUsedProperties: function(type, properties) {
            var lastUsedProperties = this.get("lastUsedProperties") || {};
            lastUsedProperties[type] = _.extend(lastUsedProperties[type] || {}, properties);
            this.set("lastUsedProperties", lastUsedProperties);
        },

        getLastUsedProperties: function(type) {
            var lastUsedProperties = this.get("lastUsedProperties");
            return lastUsedProperties ? lastUsedProperties[type] : null;
        },

        _distinguishedName: function() {
            return this.get("displayName");
        },

        /**
         * Returns true if this user has confirmed her identity, false otherwise.
         *
         * @return {Boolean} True if confirmed, false otherwise.
         */
        isConfirmed: function() {
            return this.get("confirmedAt") !== null;
        }

    }, {
        BackgroundColorCodes: BackgroundColorCodes
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/user/User.js